import { render, staticRenderFns } from "./Bots.vue?vue&type=template&id=66d23693&scoped=true"
import script from "./Bots.vue?vue&type=script&lang=js"
export * from "./Bots.vue?vue&type=script&lang=js"
import style0 from "./Bots.vue?vue&type=style&index=0&id=66d23693&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d23693",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d23693')) {
      api.createRecord('66d23693', component.options)
    } else {
      api.reload('66d23693', component.options)
    }
    module.hot.accept("./Bots.vue?vue&type=template&id=66d23693&scoped=true", function () {
      api.rerender('66d23693', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Bots.vue"
export default component.exports